<template>
  <certificates-form
    @submit="addCertificate"
    @close="onClose"
  />
</template>
<script>
import CertificatesForm from './CertificatesForm.vue'

export default {
  name: 'CreateErrorPage',
  components: {
    CertificatesForm,
  },
  data() {
    return {
      distributionId: 0,
    }
  },
  methods: {
    addCertificate(certificate) {
      this.$store.dispatch('cdn/importCertificate', certificate).then(() => {
        this.successToast('Certificate was imported')
        this.onClose()
      }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while importing certificate.') })
    },

    onClose() {
      this.$router.push({ name: 'certificates' })
    },
  },
}
</script>
